<template>
  <div>
      你已进入无人之地。
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
